// extracted by mini-css-extract-plugin
export default {"loader_container":"loader_loader_container__H8nNZ","loader":"loader_loader__qZv+U","spinner":"loader_spinner__jDssK"};